var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRareS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.61508 2H6.39261V3.14319H5.61508V2ZM4.83756 3.14312H5.60353V4.28631H4.83756V3.14312ZM7.16244 4.28678H7.92841L7.92841 5.42611H8.69438V6.56929H7.92841L7.92841 5.42997H7.16244V4.28678ZM3.30176 5.42611H4.06774V6.56929H3.30176V5.42611ZM1.76982 10.7993V8.7939L1.76982 8.49718H1V3.46639V2.70041H1.76982H2.5358V3.46254H3.30177V5.42559H2.5358V3.46639H1.76982L1.76982 8.4898H10.2302V3.46639H9.4642V5.42559H8.69823V3.46254H9.4642V2.70041H10.2302H11V3.46639V8.49718H10.2379V10.7993H1.76982ZM2.53965 10.0333H9.46805V9.26348H2.53965V10.0333ZM4.83756 4.28678H4.07159V5.42997H4.83756V4.28678ZM7.15859 3.14312H6.39261V4.28631H7.15859V3.14312Z",
    fill: "#8A88FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRareS);
export default __webpack_public_path__ + "static/media/rare-s.d3faf3c45559cbae3bcd8b3c2f7e879d.svg";
export { ForwardRef as ReactComponent };